import CountryOption from './CountryOption';
import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import withHandlers from 'recompose/withHandlers';
import withQueryParams from '../../../hocs/withQueryParams';
import { localiseUrl } from 'src/common/utils/format-localised-url';
import { withModel } from '../../../data-providers/model';
import { getCountryWithIsoAndEagleLocale } from 'src/common/l10n/country';
import { getRedirectUrl, navigate } from 'src/common/utils/get-redirect-url';
import isParamAbsoluteURL from 'src/common/utils/is-param-absolute-url';

const enhance = compose(
  withModel,
  withQueryParams,
  withProps(props => {
    const countryModel = getCountryWithIsoAndEagleLocale(props.iso, props.locale);
    return {
      countryModel,
      route: localiseUrl(countryModel, '/')
    };
  }),
  withHandlers(props => {
    const returnToUID = props.queryParams.return_to_uid;
    const returnToBlog = props.queryParams.return_to;
    let isAbsoluteUrl = isParamAbsoluteURL(returnToUID);

    return {
      handleOnClick: props => e => {
        e.preventDefault();
        let route = props.route;

        if (returnToBlog) {
          route = localiseUrl(props.countryModel, '/blog');
        }

        // If the uid is real then set the route to the correct path
        if (!isAbsoluteUrl && returnToUID) {
          route = getRedirectUrl(
            returnToUID,
            props.countryModel,
            props.model.prismicPageRedirectLanguages
          );
        }

        // Navigate to the correct route and track the event
        navigate(route, props.queryParams, {
          action: 'Change country from country page',
          from: props.model.countryModel.prefix,
          to: props.countryModel.prefix,
        });
      },
    };
  })
);

export default enhance(CountryOption);



// WEBPACK FOOTER //
// ./src/client/js/view/components/ChooseYourCountry/CountryOption/index.js